const navbarLayoutHeight = 119;
const navbarLayoutHeaderHeight = 68;
const widthTablet = 1024;
const widthMobile = 768;

const timeLoadingPage = 500;

export { navbarLayoutHeaderHeight, navbarLayoutHeight, widthTablet, widthMobile, timeLoadingPage };
